import {
  // ADD_MASTER_SUPPLIER_DATA,
  SET_MASTER_SUPPLIER,
  EDIT_MASTER_SUPPLIER,
  // SUBMIT_MASTER_SUPPLIER,
  SET_SEARCH_SUPPLIER,
  EDIT_PAPER_GRADE_NAME,
  Add_PAPER_GRADE,
  DELETE_PAPER_GRADE,
  SET_BRAND,
  Add_BRAND,
  Add_COUNTRY,
  Add_PAYMENT_TERMS,
  Add_PORT,
  DELETE_BRAND,
  DELETE_PAYMENT_TERMS,
  DELETE_COUNTRY,
  DELETE_PORT,
  EDIT_SEARCH_SUPPLIER,
  DELETE_MASTER_SUPPLIER,
  SET_DEFAULT_PAYMENT_TERM,
  ADD_SEARCH_SUPPLIER,
} from "./actionType";
import { findIndex } from "../components/common/helper";

const iniSelectSupplierData = {
  Brands: [],
  PaperGrades: [],
};

const iniState = {
  searchData: [],
  selectSupplierData: iniSelectSupplierData,
};

export default function reducer(state = iniState, action) {
  return {
    searchData: searchData(state.searchData, action),
    selectSupplierData: selectData(state.selectSupplierData, action),
  };
}

//search data
function searchData(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_SUPPLIER: {
      return [...action.payload];
    }
    case EDIT_SEARCH_SUPPLIER: {
      return [
        ...state.map((m) => {
          if (m.SupplierId === action.id)
            return {
              ...m,
              ...action.payload,
            };
          else return m;
        }),
      ];
    }
    case DELETE_MASTER_SUPPLIER: {
      let idx = findIndex(state, (f) => f.SupplierId === action.payload);
      return [...state.slice(0, idx), ...state.slice(idx + 1)];
    }
    case ADD_SEARCH_SUPPLIER: {
      return [
        ...state,
        {
          ...action.payload,
        },
      ];
    }

    default:
      return state;
  }
}

//select data
function selectData(state = iniSelectSupplierData, action) {
  switch (action.type) {
    case SET_MASTER_SUPPLIER: {
      action.payload = action.payload || iniSelectSupplierData;
      return {
        ...action.payload,
      };
    }
    case EDIT_MASTER_SUPPLIER: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    }
    case EDIT_PAPER_GRADE_NAME: {
      return {
        ...state,
        PaperGrades: [
          ...state.PaperGrades.map((m) => {
            if (m.PaperGradeId === action.payload.id)
              return {
                ...m,
                PaperGradeName: action.payload.value,
              };
            return m;
          }),
        ],
      };
    }
    case Add_PAPER_GRADE: {
      return {
        ...state,
        PaperGrades: [
          ...state.PaperGrades,
          {
            ...action.payload,
          },
        ],
      };
    }
    case DELETE_PAPER_GRADE: {
      let delIdx = findIndex(
        state.PaperGrades,
        (f) => f.PaperGradeId === action.payload
      );
      return {
        ...state,
        PaperGrades: [
          ...state.PaperGrades.slice(0, delIdx),
          ...state.PaperGrades.slice(delIdx + 1),
        ],
      };
    }
    case SET_BRAND: {
      return {
        ...state,
        Brands: [
          ...state.Brands.map((m) => {
            if (m.BrandId === action.id)
              return {
                ...action.payload,
              };
            return m;
          }),
        ],
      };
    }
    case Add_BRAND: {
      var idx = findIndex(
        state.Brands,
        (f) => f.BrandId === action.payload.BrandId
      );
      if (idx !== -1)
        return {
          ...state,
          Brands: [
            ...state.Brands.map((m) => {
              if (m.BrandId === action.payload.BrandId)
                return {
                  ...m,
                  ...action.payload,
                };
              else return m;
            }),
          ],
        };
      else
        return {
          ...state,
          Brands: [
            ...state.Brands,
            {
              ...action.payload,
            },
          ],
        };
    }
    case Add_COUNTRY: {
      let brandIdx = findIndex(
        state.Brands,
        (f) => f.BrandId === action.payload.BrandId
      );
      let countries = state.Brands[brandIdx].Countries;
      let findCountryIdx = findIndex(
        countries,
        (f) => f.Id === action.payload.Id
      );
      if (findCountryIdx === -1)
        countries = [
          ...countries,
          {
            ...action.payload,
          },
        ];
      else {
        countries = countries.map((m, idx) => {
          if (idx === findCountryIdx)
            return {
              ...m,
              ...action.payload,
            };
          else return m;
        });
      }

      return {
        ...state,
        Brands: [
          ...state.Brands.slice(0, brandIdx),
          {
            ...state.Brands[brandIdx],
            Countries: countries,
          },
          ...state.Brands.slice(brandIdx + 1),
        ],
      };
    }
    case Add_PORT: {
      let brandIdx = findIndex(
        state.Brands,
        (f) => f.BrandId === action.payload.BrandId
      );
      let ports = state.Brands[brandIdx].Ports;
      let findPortIdx = findIndex(ports, (f) => f.Id === action.payload.Id);
      if (findPortIdx === -1)
        ports = [
          ...ports,
          {
            ...action.payload,
          },
        ];
      else {
        ports = ports.map((m, idx) => {
          if (idx === findPortIdx)
            return {
              ...m,
              ...action.payload,
            };
          else return m;
        });
      }

      return {
        ...state,
        Brands: [
          ...state.Brands.slice(0, brandIdx),
          {
            ...state.Brands[brandIdx],
            Ports: ports,
          },
          ...state.Brands.slice(brandIdx + 1),
        ],
      };
    }
    case DELETE_PAYMENT_TERMS: {
      return {
        ...state,
        PaymentTermsList: state.PaymentTermsList.filter(
          (f) => f.Id !== action.id
        ),
      };
    }
    case Add_PAYMENT_TERMS: {
      let defaultPaymentTerms = state.PaymentTerms;
      if (!state.PaymentTermsList.length)
        defaultPaymentTerms = `${action.payload.Code || ""}: ${
          action.payload.Desc || ""
        }`;
      return {
        ...state,
        PaymentTermsList: [
          ...state.PaymentTermsList,
          {
            ...action.payload,
          },
        ],
        PaymentTerms: defaultPaymentTerms,
      };
    }
    case DELETE_BRAND: {
      let delIdx = findIndex(state.Brands, (f) => f.BrandId === action.payload);
      return {
        ...state,
        Brands: [
          ...state.Brands.slice(0, delIdx),
          ...state.Brands.slice(delIdx + 1),
        ],
      };
    }
    case DELETE_COUNTRY: {
      let brandIdx = findIndex(
        state.Brands,
        (f) => f.BrandId === action.brandId
      );
      return {
        ...state,
        Brands: [
          ...state.Brands.slice(0, brandIdx),
          {
            ...state.Brands[brandIdx],
            Countries: state.Brands[brandIdx].Countries.filter(
              (f) => f.Id !== action.id
            ),
          },
          ...state.Brands.slice(brandIdx + 1),
        ],
      };
    }
    case SET_DEFAULT_PAYMENT_TERM: {
      let findPaymentTerm = state.PaymentTermsList.find(
        (f) => f.Id === action.id
      );
      return {
        ...state,
        PaymentTerms: `${findPaymentTerm.Code || ""}: ${
          findPaymentTerm.Desc || ""
        }`,
      };
    }
    case DELETE_PORT: {
      let brandIdx = findIndex(
        state.Brands,
        (f) => f.BrandId === action.brandId
      );
      return {
        ...state,
        Brands: [
          ...state.Brands.slice(0, brandIdx),
          {
            ...state.Brands[brandIdx],
            Ports: state.Brands[brandIdx].Ports.filter(
              (f) => f.Id !== action.id
            ),
          },
          ...state.Brands.slice(brandIdx + 1),
        ],
      };
    }
    default:
      return state;
  }
}
